
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import TkProcessSelectionButton from "../input/TkProcessSelectionButton";
import { debounce } from 'lodash';
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import TkOrderBuyerDetailProcess from "./TkOrderBuyerDetailProcess";

function TkProcessSelectionByOrderBuyerDetail(props) {

    const {onSelectMst} = props;

    const id = "TkProcessSelectionByOrderBuyerDetail";
    const view = "TkVwOrderBuyerDetailNotDelivered"

    const { t } = useTranslation();

    const [grid, setGrid] = useState();
    const [detailApi, setDetailApi] = useState();
    
    const [ isEmpty, setIsEmpty ] = useState();
    const [ orderBuyerDetailByProcessApi , setOrderBuyerDetailByProcessApi] = useState();

    const [onSelectOrderBuyerDetail, setOnSelectOrderBuyerDetail] = useState([]);

    const setNotification = useSetRecoilState(notificationState);

    const [height, setHeight] = useState(0);

    const [orderBuyerDetailByProcessGrid, setOrderBuyerDetailByProcessGrid] = useState();

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        window.addEventListener('resize', handleResize);
        handleResize();

        return ( () => {
            window.removeEventListener('resize', handleResize);
        } );


    }, []);


    useEffect ( () => {

        if ( detailApi ) {

            detailApi.refresh ();

        }

    }, [onSelectMst.orderBuyerId] )

    useEffect(()=>{

        if (grid) {
            
            grid.selectionChanged.addHandler(debounce((grid, event) => {

                if (grid.selectedItems) {
                    setOnSelectOrderBuyerDetail(grid.selectedItems);

                } else {

                    setOnSelectOrderBuyerDetail([]);

                };

            }, 10));

            grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                if (grid.selectedItems) {

                    setOnSelectOrderBuyerDetail(grid.selectedItems);

                } else {

                    setOnSelectOrderBuyerDetail([]);

                };

            }, 10));
        }

    },[grid]);

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };


    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const onGridInitialized = (grid) => {

        grid.selectionMode = "ListBox";
        
        setGrid(grid);

    };
    const onOrderBuyerDetailByProcessGridInitialized = (grid) => {

        setOrderBuyerDetailByProcessGrid(grid);

    };

    const onModifyUrl = ( url, orderBuyerId ) => {

        return url + "/" + orderBuyerId;

    };

    const onApiInitialized = ( api ) => {

        setDetailApi ( api );

    };

    const onOrderBuyerDetailByProcessApiInitialized = ( api ) => {

        setOrderBuyerDetailByProcessApi ( api );

    };

    const onLoadData = (data) => {

        let isEmpty = data.length < 1 ? true : false;

        setIsEmpty(isEmpty);

    };


    return (

        <div style={{ height: height }} >

            <ReflexContainer orientation="horizontal">

            <ReflexElement flex={onSelectOrderBuyerDetail?.length === 1 ? 0.6 : 1}>

                <BasicCrudScreenType
                    id={id}
                    headerTitle={t("term.soDetail")}
                    view={view}
                    noCreate
                    noEdit
                    noDelete
                    noExcel
                    onInitialized={onGridInitialized}
                    onApiInitialized= {onApiInitialized}
                    onLoadData= {onLoadData}
                    onModifyViewUrl={( url ) => onModifyUrl ( url, onSelectMst.orderBuyerId )}
                    onAppendButtonInFrontOfSearch = {()=>(
                        <>
                        <BasicCrudScreenActionItemLayout>
                            <TkProcessSelectionButton
                                id = {id}
                                selectItems = {onSelectOrderBuyerDetail}
                                orderBuyerDetailByProcessGrid = {orderBuyerDetailByProcessGrid}
                                onSuccess = {onSuccess}
                                disabled = {isEmpty}
                                orderBuyerDetailByProcessApi = {orderBuyerDetailByProcessApi}
                            />
                        </BasicCrudScreenActionItemLayout>
                        </>
        
                    )}
                />

            </ReflexElement>

            <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

            <ReflexElement>
                <TkOrderBuyerDetailProcess
                    selectItems = {onSelectOrderBuyerDetail}
                    onInitialized = {onOrderBuyerDetailByProcessGridInitialized}
                    onApiInitialized = {onOrderBuyerDetailByProcessApiInitialized}
                />
            </ReflexElement>

            </ReflexContainer>

            
        </div>
    );

}

export default TkProcessSelectionByOrderBuyerDetail;
